import React from "react"
import {Form, Header, Item, Message, Divider} from "semantic-ui-react"
import { Link } from "react-router-dom";
import {callService, PATCH, POST} from "../../shared/serviceInvoker";
import {changePasswordURL, verifyPasswordTokenURL} from "../../shared/urls/clientapi";

import TermsAndPrivacy from "../../shared/components/TermsAndPrivacy";
import MessageErrorSuccess from "../../shared/components/MessageErrorSuccess";
import MessageSuccess from "../../shared/components/MessageSuccess";
import Redirect from "react-router-dom/es/Redirect";
import {homeURL, passwordHelpURL} from "../../shared/urls/app";
import {signIn} from "../../shared/auth";
import {checkMinLength} from "../../shared/helpers/validators";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';

const PASSWORD_LENGTH_MSG = 'Use 8 or more characters';
const PASSWORD_UPPER_LOWER_MSG = 'Use upper and lower case letters (e.g. Aa)';
const PASSWORD_NUMBER_MSG = 'Use a number (e.g. 1234)';
const PASSWORD_SYMBOL_MSG = 'Use a symbol (e.g. !@#$)';

const messages = {
  success: {
    passwordLength: PASSWORD_LENGTH_MSG,
    passwordUpperLower: PASSWORD_UPPER_LOWER_MSG,
    passwordNumber: PASSWORD_NUMBER_MSG,
    passwordSymbol: PASSWORD_SYMBOL_MSG,
    confirmPassword: 'Passwords match'
  },
  error: {
    passwordLength: PASSWORD_LENGTH_MSG,
    passwordUpperLower: PASSWORD_UPPER_LOWER_MSG,
    passwordNumber: PASSWORD_NUMBER_MSG,
    passwordSymbol: PASSWORD_SYMBOL_MSG,
    confirmPassword: 'Passwords do not match'
  }
};

export default class ChangePassword extends React.Component {
  constructor(props) {
    super(props); 
    this.state = {
      redirectOn: props.redirectOn || false,
      header: props.header || '',
      showTerms: props.showTerms || false,
      url: props.url || changePasswordURL,
      tokenURL: verifyPasswordTokenURL,
      password: '',
      confirmPassword: '',
      passwordLength: false,
      passwordUpperLower: false,
      passwordNumber: false,
      passwordSymbol: false,
      confirmPasswordValid: false,
      formValid: false,
      redirectToReferrer: false,
      error: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateForm = this.validateForm.bind(this);
  }

  componentDidMount() {
    let bodyFormData = new FormData();
    if (this.props.match && this.props.match.params) {
      bodyFormData.append('token', this.props.match.params.passwordToken);
      callService(
        POST,
        this.state.tokenURL,
        bodyFormData,
        response => {
          this.setState({ error: false });
        },
        error => {
          this.setState({ redirectToReferrer: true, error: true });
        }
      );
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState(
      {[name]: value},
      () => {this.validateField(name, value)}
    );
  }

  validateField(fieldName, value) {
    let passwordLength = this.state.passwordLength;
    let passwordUpperLower = this.state.passwordUpperLower;
    let passwordNumber = this.state.passwordNumber;
    let passwordSymbol = this.state.passwordSymbol;
    let confirmPasswordValid = this.state.confirmPasswordValid;
    switch(fieldName) {
      case 'password':
        passwordLength = checkMinLength(value, 8);
        passwordUpperLower = value.match(/^(?=.*[A-Z])(?=.*[a-z]).*$/);
        passwordNumber = value.match(/[\d]/);
        passwordSymbol = value.match(/[\W_]/);
        confirmPasswordValid = value === this.state.confirmPassword;
        break;
      case 'confirmPassword':
        confirmPasswordValid = value === this.state.password;
        break;
      default:
        break;
    }
    this.setState(
      {
        passwordLength: passwordLength,
        passwordUpperLower: passwordUpperLower,
        passwordNumber: passwordNumber,
        passwordSymbol: passwordSymbol,
        confirmPasswordValid: confirmPasswordValid,
      },
      this.validateForm
    )
  }

  validateForm() {
    this.setState(
      {
        formValid: this.state.passwordLength && this.state.passwordUpperLower && this.state.passwordNumber &&
        this.state.passwordSymbol && this.state.confirmPasswordValid
      }
    )
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { password } = this.state;

    let bodyFormData = new FormData();
    bodyFormData.append('password', password);
    if (this.props.match && this.props.match.params) {
      bodyFormData.append('token', this.props.match.params.passwordToken);
    }

    callService(
      PATCH,
      this.state.url,
      bodyFormData,
      response => {
        signIn();
        sessionStorage.setItem("first_name", response.data.data.first_name);
        sessionStorage.setItem("contact_id", response.data.data.contact_id);
        sessionStorage.setItem("user_id", response.data.data.user_id);
        sessionStorage.setItem("autoplay_launched", 'false');
        this.setState({ redirectToReferrer: true });
        ReactGA.set({ userId: response.data.data.contact_id });
        ReactGA.ga('set', 'dimension1', response.data.data.contact_id.toString());
        ReactGA.event({
          category: 'Profile',
          action: 'Password Changed',
        });
        trackEvent('Profile', 'Password Changed');
        if (this.props.onSuccess !== undefined){
          this.props.onSuccess();  
        }     
      },
      error => {
        this.setState({ redirectToReferrer: true, error: true });
      }
    );
  };

  render() {
    const {password, confirmPassword, redirectToReferrer, error, redirectOn, header, formValid, showTerms} = this.state;

    if (redirectOn && redirectToReferrer) {
      if (error) {
        this.props.history.push({pathname: passwordHelpURL, state: {error: error}})
      }
      else {
        return <Redirect to={homeURL} />;
      }
    }

    return (
      <span>
        {
          header ?
            <span>
              <Header as='h1'>{header}</Header>
            </span>
          :
            null
        }
        <Header as='h4'>Be sure to create a password you've never used before. That's the best way to keep your account safe.</Header>
        <Form onSubmit={this.handleSubmit}>
          <Item style={{ textAlign: 'left' }} >Password</Item>
          <Form.Input
            fluid
            icon='lock'
            iconPosition='left'
            placeholder='Password'
            type='password'
            required
            name='password' value={password}
            onChange={this.handleInputChange}
          />
          <Item style={{ textAlign: 'left' }} >Confirm Password</Item>
          <Form.Input
            fluid
            icon='lock'
            iconPosition='left'
            placeholder='Confirm Password'
            type='password'
            required
            name='confirmPassword' value={confirmPassword}
            onChange={this.handleInputChange}
          />

          <div>
            <MessageErrorSuccess correct={this.state.passwordLength} errorMsg={messages.error.passwordLength} successMsg={messages.success.passwordLength}/>
            <MessageErrorSuccess correct={this.state.passwordUpperLower} errorMsg={messages.error.passwordUpperLower} successMsg={messages.success.passwordUpperLower}/>
            <MessageErrorSuccess correct={this.state.passwordNumber} errorMsg={messages.error.passwordNumber} successMsg={messages.success.passwordNumber}/>
            <MessageErrorSuccess correct={this.state.passwordSymbol} errorMsg={messages.error.passwordSymbol} successMsg={messages.success.passwordSymbol}/>
            <MessageErrorSuccess correct={this.state.confirmPasswordValid} errorMsg={messages.error.confirmPassword} successMsg={messages.success.confirmPassword}/>
          </div>
          {
            formValid ?
              <span>
                <MessageSuccess textAlign='center' message="You're good to go!"/><br />
              </span>
            :
              <br />
          }

          <Form.Button color='blue' fluid size='large' icon='lock' content='Continue' disabled={!formValid} />

          {
            !redirectOn && redirectToReferrer ?
              <Message size='tiny' icon='checkmark' color='green' content='Password was updated successfully!' />
            :
              null
          }

          { 
            showTerms ? 
              <span>
                <TermsAndPrivacy btnContent="Continue" /> 
                <Divider />
                <Item as={Link} to='/login'>Return to Sign In page</Item> 
              </span>
            : 
              null             
            }
          
                   
        </Form>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChangePassword/index.js